// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__hyq8_","info":"Note_info__26Ycf","note":"Note_note__3PIC7","actions":"Note_actions__P782z"};